import * as React from 'react';

const RoutesSwitch = React.lazy(() => import('./presenter'));

export default () => <RoutesSwitch />;
